import React from 'react';
import { Text } from '@radix-ui/themes';
import roleplayIcon from '../../../../assets/images/roleplay.png';

const RpEndWait = () => {
  return (
    <div className="flex flex-1 justify-center items-center">
      <img
        src={roleplayIcon}
        alt="Roleplay"
        className="h-[20vh] w-[35vw] max-h-[150px] max-w-[200px] object-contain"
      />
      <Text
        as="span"
        size="2"
        className="text-white py-[1.5vh] font-[Lato-Regular] text-center w-[60vw]"
      >
        Case Study & Analysis in your group has ended
      </Text>
      <Text
        as="span"
        size="4"
        className="text-white pt-0 font-[Lato-Regular] text-center w-[60vw] mb-[1vh]"
      >
        Standby for further instructions from Trainer
      </Text>
    </div>
  );
};

export default RpEndWait;